import styled from 'styled-components';
import HappyArrowDropSvg from './happyArrowDrop.svg';

const HappyArrowDropIcon = styled(HappyArrowDropSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  cursor: pointer;
  transform: ${props => (props.rotateReverse ? 'rotate(180deg)' : '')};
`;

export default HappyArrowDropIcon;
